import { render, staticRenderFns } from "./BaseCustomer.vue?vue&type=template&id=5b449633&scoped=true&"
import script from "./BaseCustomer.vue?vue&type=script&lang=js&"
export * from "./BaseCustomer.vue?vue&type=script&lang=js&"
import style0 from "./BaseCustomer.vue?vue&type=style&index=0&id=5b449633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b449633",
  null
  
)

export default component.exports